<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Formulário
      <router-link slot="right" to="/" class="button"> Dashboard </router-link>
    </hero-bar>

    <section class="section is-main-section">
      <pessoa-form />
      
      <!-- Mantenha a parte de documentos aqui se necessário -->
      <form-documentos v-if="$route.params.id" :pessoa-id="$route.params.id" />
    </section>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import HeroBar from '@/components/HeroBar.vue';
import PessoaForm from '@/components/Form/FormCreatePessoa.vue';
import FormDocumentos from '@/components/Form/FormDocumentos.vue';

export default {
  components: {
    TitleBar,
    HeroBar,
    PessoaForm,
    FormDocumentos
  },
  data() {
    return {
      titleStack: ["SECAPI", "Pessoas", "Cadastrar ou Alterar Pessoa"]
    };
  }
};
</script>